import { City } from "./city.model";
import { LatLng, PaginationFilterRequest } from "./core.model";

export interface Route {
    id: number;
    name: string;
    length: number;
    path: LatLng[];
    cityId: number;
    city: City;
    hasAchievement: boolean;
}

export interface UpsertRoute {
    id?: number;
    name?: string;
    length?: number;
    path?: LatLng[];
    cityId?: number;
}

export class RoutePaginationFilterRequest extends PaginationFilterRequest{  
    cityId?: number;
    countryId?: number;
}
